import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../styles/Header.css';

const NAV = [
  { to: '/', label: 'Home', end: true },
  { to: '/upcoming-matches', label: 'Upcoming' },
  { to: '/completed-matches', label: 'Results' },
];

const Header = () => (
  <header className="site-header">
    <div className="container">
      <nav className="main-nav">
        <Link to="/" className="logo" aria-label="JoltStats home">
          <svg className="logo-bolt" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path d="M13.5 2 5 13.2h5.1L9.6 22 19 10.4h-5.6z" fill="currentColor" />
          </svg>
          <span className="logo-text"><strong>Jolt</strong>Stats</span>
        </Link>

        <ul className="nav-links">
          {NAV.map(item => (
            <li className="nav-item" key={item.to}>
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  </header>
);

export default Header;
